import CloseIcon from "@mui/icons-material/Close";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Box, IconButton, Typography } from "@mui/material";

export const MEDIA_GENERATION_ERROR_TITLE = "Please try again or adjust your input";

export const MEDIA_GENERATION_ERROR_BODY =
  "The request couldn't be processed due to content restrictions or a temporary issue with the service.";

export interface MediaGenerationErrorAlertProps {
  readonly onClose: () => void;
}

export function MediaGenerationErrorAlert({ onClose }: MediaGenerationErrorAlertProps) {
  return (
    <Box
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="media-generation-error-title"
      aria-describedby="media-generation-error-body"
      sx={{
        position: "fixed",
        top: 24,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: (theme) => theme.zIndex.snackbar + 1,
        width: "min(560px, calc(100vw - 32px))",
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        px: 2,
        py: 1.75,
        bgcolor: "background.default",
        border: "1px solid",
        borderColor: "warning.main",
        borderRadius: 1,
        boxShadow: 6
      }}
    >
      <WarningAmberOutlinedIcon sx={{ color: "warning.main", fontSize: 28, mt: 0.25, flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0, pr: 1 }}>
        <Typography id="media-generation-error-title" variant="subtitle1" sx={{ color: "text.primary", mb: 0.5, fontWeight: 600 }}>
          {MEDIA_GENERATION_ERROR_TITLE}
        </Typography>
        <Typography id="media-generation-error-body" variant="body2" sx={{ color: "text.secondary" }}>
          {MEDIA_GENERATION_ERROR_BODY}
        </Typography>
      </Box>
      <IconButton aria-label="Close" onClick={onClose} size="small" sx={{ color: "text.primary", mt: -0.5, mr: -0.5 }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
